(function () {
  function getIconMap() {
    const el = document.getElementById("menu-icons-data");
    if (!el) return null;

    try {
      const arr = JSON.parse(el.textContent || "[]");
      const map = new Map();
      arr.forEach((item) => {
        if (!item || !item.title || !item.icon) return;
        map.set(String(item.title).trim(), String(item.icon));
      });
      return map.size ? map : null;
    } catch (e) {
      return null;
    }
  }

  function normalizeTitle(str) {
    return String(str || "").replace(/\s+/g, " ").trim();
  }

  function injectIcons(root) {
    const map = getIconMap();
    if (!map) return;

    const scope = root && root.querySelectorAll ? root : document;

    const links = scope.querySelectorAll(
      "header-menu a, .header-menu a, .menu-list a, .menu-drawer a"
    );

    links.forEach((a) => {
      if (!a) return;

      // If it already has our icon, skip
      if (a.querySelector("img.menu-icon")) return;

      const title = normalizeTitle(a.textContent);
      if (!title) return;

      const iconUrl = map.get(title);
      if (!iconUrl) return;

      const img = document.createElement("img");
      img.className = "menu-icon";
      img.src = iconUrl;
      img.alt = "";
      img.loading = "lazy";

      const span = a.querySelector("span");
      if (span) a.insertBefore(img, span);
      else a.insertBefore(img, a.firstChild);

      a.classList.add("has-menu-icon");
    });
  }

  let t = null;
  function reinjectSoon() {
    window.clearTimeout(t);
    t = window.setTimeout(function () {
      injectIcons(document);
    }, 60);
  }

  function boot() {
    // First pass
    injectIcons(document);

    // Second pass after initial theme scripts settle
    window.setTimeout(reinjectSoon, 250);
    window.setTimeout(reinjectSoon, 900);

    // Watch only header area for performance
    const headerRoot =
      document.getElementById("header-group") ||
      document.getElementById("header-component") ||
      document.querySelector("header-component") ||
      document.documentElement;

    const obs = new MutationObserver(function () {
      // Any mutation in header can wipe icons, so re-run (debounced)
      reinjectSoon();
    });

    obs.observe(headerRoot, {
      childList: true,
      subtree: true,
      attributes: true
    });

    // Theme editor and section hydration events
    document.addEventListener("shopify:section:load", reinjectSoon);
    document.addEventListener("shopify:section:select", reinjectSoon);
    document.addEventListener("shopify:section:deselect", reinjectSoon);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
